module.exports = __webpack_public_path__ + "img/nonProfit_store.b0f1902a.svg";